import { FC } from 'react';

import { SkeletonWrapper } from './styles';

export type SkeletonProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
};

export const Skeleton: FC<SkeletonProps> = ({
  width = '100%',
  height = '100%',
  borderRadius,
}) => {
  return (
    <SkeletonWrapper
      width={width}
      height={height}
      borderRadius={borderRadius}
    />
  );
};
